import tree from "../../../components/tree.vue";
import DataPage from "./DataPage/DataPage.vue";
import MonthTime from "./MonthTime/MonthTime.vue";
import ChangeTime from "./ChangeTime/ChangeTime.vue";

export default {
  name: "MaintenanceAnalysis",
  components: {
    tree,
    DataPage,
    MonthTime,
    ChangeTime
  },
  data() {
    return {
      isCollapse: false,
      stateArrow: true,
      isSearch: true,
      activeName: 'first',
      orgId: '',
    };
  },
  mounted() {

  },
  methods: {
    toggleSideBar() {
      this.isCollapse = !this.isCollapse
      this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
    },
    changeArrow() {
      this.stateArrow = !this.stateArrow
    },
    handleClick(event) {
      this.activeName = event.name
      if (this.activeName == 'first') {
        this.$nextTick(() => {
          this.$refs.monthTime.orgId = this.orgId
          this.$refs.monthTime.queryMaintainCost()
          this.$refs.monthTime.maintainCostCompare()
          this.$refs.monthTime.getMonthOrderList()
        })
      } else if (this.activeName == 'second') {
        this.$nextTick(() => {
          this.$refs.dataRef.orgId = this.orgId
          this.$refs.dataRef.queryMaintainCost()
          this.$refs.dataRef.maintainCostCompare()
          this.$refs.dataRef.getTotalOrderList()
        })
      } else {
        this.$nextTick(() => {
          this.$refs.changeTime.orgId = this.orgId
          this.$refs.changeTime.queryMaintainCost()
          this.$refs.changeTime.maintainCostCompare()
          this.$refs.changeTime.getChangeOrderList()
        })

      }
    },
    initQuery(item) {
      this.orgId = item.id
      this.$refs.monthTime.orgId = item.id
      this.$refs.monthTime.queryMaintainCost()
      this.$refs.monthTime.maintainCostCompare()
      this.$refs.monthTime.getMonthOrderList()
    },
    nodeClick(val) {
      this.orgId = val.label
      if (this.activeName == 'first') {
        this.$refs.monthTime.orgId = val.label
        this.$refs.monthTime.queryMaintainCost()
        this.$refs.monthTime.maintainCostCompare()
        this.$refs.monthTime.getMonthOrderList()
      } else if (this.activeName == 'second') {
        this.$refs.dataRef.orgId = val.label
        this.$refs.dataRef.queryMaintainCost()
        this.$refs.dataRef.maintainCostCompare()
        this.$refs.dataRef.getTotalOrderList()
      } else {
        this.$refs.changeTime.orgId = val.label
        this.$refs.changeTime.queryMaintainCost()
        this.$refs.changeTime.maintainCostCompare()
        this.$refs.changeTime.getChangeOrderList()
      }
    },
    onResize: function (x, y, width, height) {
      let box = document.getElementById("leftBox");
      box.style.width = width + "px";
    },
  },
};
